import { noop } from '@tanstack/react-query';
import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';
import { Main, MainPending } from '@/ui/components/main';
import { bidDetailsQuery } from '@/features/bids/queries';
import { bidMethodologyVersionsQuery } from '@/features/bid-methodology/queries';
import { bidCvDetailsQuery } from '@/features/bid-cvs/queries';
import { bidComplianceQuery } from '@/features/bid-compliance/queries';
import { lastOpenedBidByTenderAtom } from '@/features/bids/store';
import { getDefaultStore } from 'jotai';
import { VersionHistoryPanel } from '@/features/workspaces/components/version-history-panel';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout',
)({
  staticData: { chatSurface: 'bid' },
  component: RouteComponent,
  loader: async (opts) => {
    opts.context.queryClient.query(bidMethodologyVersionsQuery(opts.params.bidId)).catch(noop);
    opts.context.queryClient.query(bidCvDetailsQuery(opts.params.bidId)).catch(noop);
    opts.context.queryClient
      .query(bidComplianceQuery(opts.params.workspaceId, opts.params.bidId))
      .catch(noop);
    const bid = await opts.context.queryClient.query({
      ...bidDetailsQuery(opts.params.bidId),
      staleTime: 'static',
    });
    if (!bid) throw notFound();
    getDefaultStore().set(lastOpenedBidByTenderAtom, (prev) => ({
      ...prev,
      [opts.params.workspaceId]: opts.params.bidId,
    }));
  },
  pendingComponent: MainPending,
});

function RouteComponent() {
  return (
    <Main className="flex flex-row">
      <div className="grow flex flex-col min-w-0">
        <Outlet />
      </div>
      <VersionHistoryPanel />
    </Main>
  );
}
